class ct_atc_form extends HTMLElement {
  constructor() {
    super();
    this.querySelector(".ct-atc-button").addEventListener("click", this.submit.bind(this));
    this.querySelector(".ct-atc-wishlist").addEventListener("click", () => {
      this.toggleWishlist(this.querySelector(".ct-atc-wishlist").querySelector("svg:not([disabled])"));
    });
    this.applyWishlist();
  }
  submit() {
    const button = this.querySelector(".ct-atc-button");
    if(!button.disabled && !button.hasAttribute("soldout") && !button.hasAttribute("submitted") && this.getAttribute("variant-id")) {
      this.querySelector(".ct-atc-button").setAttribute("submitted", "");
      button.disabled = true;
      const variant = this.getAttribute("variant-id");
      const quantity = this.getAttribute("quantity") ? parseInt(this.getAttribute("quantity")) : 1;
      let formData = {
       'items': [{
        'id': variant,
        'quantity': quantity
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Unable to add item to cart');
        document.querySelector("ct-cart-drawer")?.heavyDrawerUpdate();
        if (window._learnq && window.item) window._learnq.push(['track', 'Added to Cart', window.item]);
        return data;
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {
        button.removeAttribute("submitted");
        button.disabled = button.hasAttribute("soldout");
      });
    }
  }
  toggleWishlist(element) {
    if(element.hasAttribute("wl-first")) {
      element.setAttribute("disabled", "");
      element.nextElementSibling.removeAttribute("disabled");
      let wishlistArray = [];
      if(localStorage.getItem("wishlist")) {
        wishlistArray = JSON.parse(localStorage.getItem("wishlist"));
      }
      const prodID = this.getAttribute("data-id");
      const currentPath = window.location.pathname;
      const prodHandle = currentPath.replace("/products/", "");
      let newItem = {
        id: prodID,
        handle: prodHandle
      }
      wishlistArray.push(newItem);
      localStorage.setItem("wishlist", JSON.stringify(wishlistArray));
    } else if(element.hasAttribute("wl-second")) {
      element.setAttribute("disabled", "");
      element.previousElementSibling.removeAttribute("disabled");
      let wishlistArray = [];
      if(localStorage.getItem("wishlist")) {
        wishlistArray = JSON.parse(localStorage.getItem("wishlist"));
      }
      const prodID = this.getAttribute("data-id");
      wishlistArray = wishlistArray.filter(item => item.id !== prodID);
      localStorage.setItem("wishlist", JSON.stringify(wishlistArray));
      if(wishlistArray.length == 0) {
        localStorage.removeItem("wishlist");
      }
    }
    const header = document.querySelector("ct-header");
    header.buildWishList();
  }
  applyWishlist() {
    const prodID = this.getAttribute("data-id");
    if(localStorage.getItem("wishlist")) {
      const wishlistArray = JSON.parse(localStorage.getItem("wishlist"));
      let itemToFind = wishlistArray.find(item => item.id === prodID);
      if(itemToFind) {
        const element = this.querySelector(".ct-atc-wishlist svg[wl-first]");
        element.setAttribute("disabled", "");
        element.nextElementSibling.removeAttribute("disabled");
      }
    }
  }
}
customElements.define("ct-atc-form", ct_atc_form);
